import { render, staticRenderFns } from "./LinkedInSettingsCard.vue?vue&type=template&id=1f39f624"
import script from "./LinkedInSettingsCard.vue?vue&type=script&lang=ts"
export * from "./LinkedInSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports